import { render, staticRenderFns } from "./OwnerNewStaff.vue?vue&type=template&id=e0ca2f86&"
import script from "./OwnerNewStaff.vue?vue&type=script&lang=ts&"
export * from "./OwnerNewStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports